<div class="info-card wide-card" *ngIf="rows.length" data-test="client-preoffers">
  <div class="card-header">
    <i class="fa-solid fa-file-signature text-indigo-500" aria-hidden="true"></i>
    <h3>Preoferta</h3>
  </div>
  <div class="card-content">
    <ul class="cp-rows">
      <li *ngFor="let row of rows" class="cp-row" data-test="client-preoffer-row">
        <button type="button" class="cp-row__link" (click)="open()">Ver en la Calculadora</button>
        <span class="cp-pill" [ngClass]="'is-' + (row.view?.tone || 'neutral')" [class.is-dashed]="row.view?.dashed">{{
          row.view?.label || row.preoffer.status
        }}</span>
        <span class="cp-row__line">{{ row.view?.lines?.[0] }}</span>
      </li>
    </ul>
  </div>
</div>
